import React, { useState, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Select, Input, Radio, message } from "antd";
import { UserContext } from "../../context/userContext";
import "./CheckoutNow.scss";
import {
  postOrders,
  updateProductStock,
  patchStockProduct,
} from "../../services/checkout/checkout";
import { get } from "../../utils/request";
import { formatNumber } from "../../helper/fomartNum";
import { priceNew } from "../../helper/priceNew";

function CheckoutNow() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { currentUser } = useContext(UserContext);

  const [productData, setProductData] = useState(state?.buyNowProduct || null);

  const [provinceList, setProvinceList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [wardList, setWardList] = useState([]);

  const [province, setProvince] = useState(null);
  const [district, setDistrict] = useState(null);
  const [ward, setWard] = useState(null);

  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("cod");

  const [isPaid, setIsPaid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shipFee, setShipFee] = useState(0);

  const [messageApi, contextHolder] = message.useMessage();

  // LOAD TỈNH
  useEffect(() => {
    fetch("https://provinces.open-api.vn/api/p/")
      .then((res) => res.json())
      .then((data) => setProvinceList(data))
      .catch(() => messageApi.error("Không tải được tỉnh / thành"));
  }, []);

  const handleProvinceChange = (value, option) => {
    const code = option.code;
    const name = option.label;

    setProvince({ code, name });
    setDistrict(null);
    setWard(null);
    setDistrictList([]);
    setWardList([]);

    const shipFees = {
      "Thành phố Hồ Chí Minh": 20000,
      "Thành phố Hà Nội": 25000,
      "Tỉnh Đà Nẵng": 18000,
    };

    setShipFee(shipFees[name] || 30000);

    fetch(`https://provinces.open-api.vn/api/p/${code}?depth=2`)
      .then((res) => res.json())
      .then((data) => setDistrictList(data.districts || []))
      .catch(() => messageApi.error("Không tải được quận / huyện"));
  };

  const handleDistrictChange = (value, option) => {
    const code = option.code;
    const name = option.label;

    setDistrict({ code, name });
    setWard(null);
    setWardList([]);

    fetch(`https://provinces.open-api.vn/api/d/${code}?depth=2`)
      .then((res) => res.json())
      .then((data) => setWardList(data.wards || []))
      .catch(() => messageApi.error("Không tải được phường / xã"));
  };

  const handleSubmit = async () => {
    if (!currentUser) {
      messageApi.warning("Vui lòng đăng nhập!");
      navigate("/login");
      return;
    }

    if (!province || !district || !ward || !address || !phone) {
      messageApi.error("Vui lòng nhập đủ thông tin.");
      return;
    }

    if (!productData) {
      messageApi.error("Không tìm thấy sản phẩm.");
      return;
    }

    setLoading(true);

    try {
      const price_current = priceNew(productData.price_old, productData.sales);

      await postOrders({
        username: currentUser.username,
        products: [{ ...productData, stock: false }],
        total: price_current + shipFee,
        shipping: shipFee,
        address: `${address}, ${ward.name}, ${district.name}, ${province.name}`,
        phone,
        paymentMethod,
        status: "Đã thanh toán",
        createdAt: new Date().toISOString(),
      });

      await updateProductStock(productData.idProducts, false);

      const headers = await get("headers-products");
      const header = headers.find((h) =>
        h.products?.some((p) => p.idProducts === productData.idProducts)
      );

      if (header?.key) {
        await patchStockProduct(header.key, productData.idProducts, false);
      }

      setIsPaid(true);
      messageApi.success("Đặt hàng thành công!");
    } catch (err) {
      console.error(err);
      messageApi.error("Thanh toán thất bại!");
    }

    setLoading(false);
  };

  const priceCurrent = priceNew(productData.price_old, productData.sales);

  return (
    <div className="checkout-now">
      {contextHolder}

      {isPaid ? (
        <div className="checkout-success">
          <h3>✅ Đặt hàng thành công!</h3>
          <p>Chúng tôi sẽ sớm liên hệ giao hàng.</p>
          <Button onClick={() => navigate("/")} className="btn-home">
            Về trang chủ
          </Button>
        </div>
      ) : (
        <>
          {!productData ? (
            <div>Không có sản phẩm để thanh toán.</div>
          ) : (
            <>
              <h2>Thanh toán sản phẩm</h2>

              <div className="checkout-product-section">
                <div className="checkout-product-info">
                  <img src={productData.thumbnail1} alt={productData.name} />
                  <div className="checkout-info">
                    <div className="checkout-name">
                      {productData.title || productData.name}
                    </div>
                    <div className="checkout-size">{productData.size}</div>
                    <div className="checkout-price">
                      Giá:{" "}
                      <span className="price">
                        {formatNumber(priceCurrent)}đ
                      </span>
                    </div>
                    <div>Phí ship: {formatNumber(shipFee)}đ</div>
                    <div className="checkout-total">
                      Tổng:{" "}
                      <span className="total-free">
                        {formatNumber(priceCurrent + shipFee)}đ
                      </span>
                    </div>
                  </div>
                </div>

                <div className="checkout-input">
                  <Input
                    variant="borderless"
                    className="checkout-input-phone"
                    placeholder="Số điện thoại"
                    value={phone}
                    onChange={(e) =>
                      setPhone(e.target.value.replace(/\D/g, ""))
                    }
                  />

                  <Select
                    variant="borderless"
                    className="checkout-select-city"
                    placeholder="Tỉnh/Thành"
                    onChange={handleProvinceChange}
                    options={provinceList.map((p) => ({
                      value: p.code,
                      label: p.name,
                      code: p.code,
                    }))}
                  />

                  <Select
                    variant="borderless"
                    className="checkout-select-city"
                    placeholder="Quận/Huyện"
                    disabled={!province}
                    onChange={handleDistrictChange}
                    options={districtList.map((d) => ({
                      value: d.code,
                      label: d.name,
                      code: d.code,
                    }))}
                  />

                  <Select
                    variant="borderless"
                    className="checkout-select-city"
                    placeholder="Phường/Xã"
                    disabled={!district}
                    onChange={(value, option) =>
                      setWard({ code: option.code, name: option.label })
                    }
                    options={wardList.map((w) => ({
                      value: w.code,
                      label: w.name,
                      code: w.code,
                    }))}
                  />

                  <Input
                    variant="borderless"
                    className="checkout-input-phone"
                    placeholder="Địa chỉ chi tiết"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />

                  <Radio.Group
                    className="checkout-choice"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                  >
                    <Radio value="cod">COD</Radio>
                    <Radio value="momo" disabled>
                      Momo
                    </Radio>
                    <Radio value="bank" disabled>
                      Bank
                    </Radio>
                  </Radio.Group>

                  <Button
                    className="checkout-btn-buy"
                    loading={loading}
                    onClick={handleSubmit}
                    type="primary"
                    block
                    size="large"
                  >
                    {loading ? "Đang xử lý..." : "Xác nhận mua"}
                  </Button>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}

export default CheckoutNow;
